export const getStringWithoutHtml = (stringHtml = "") => {
    return stringHtml.replace(/<\/?p[^>]*>/gi, "");
}